import { render } from "./footer-menu.vue?vue&type=template&id=75e74311&scoped=true"
import script from "./footer-menu.vue?vue&type=script&lang=js"
export * from "./footer-menu.vue?vue&type=script&lang=js"

import "./footer-menu.vue?vue&type=style&index=0&id=75e74311&scoped=true&lang=scss"

import exportComponent from "/builds/septacodeprojects/septacode.com/frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75e74311"]])

export default __exports__